export default "__VITE_ASSET__fPXbQpeH__"